import React from "react";
import classNames from "classnames";
import {FaAddressBook, FaPeopleGroup} from "react-icons/fa6";

// Icon ghép cho "Danh Bạ Công Giáo" - GHÉP 2 icon (sổ danh bạ = Danh Bạ + nhóm người = các cộng
// đoàn/tổ chức được liệt kê trong đó - Kristo Directory gộp dioceses/parishes + religious orders +
// Catholic Action + organizations + yellow pages, xem comment ở chỗ khai báo entry 'directories').
// KHÔNG dùng lại thánh giá (đã dùng ở HymnIcon) hay nhà thờ (đã dùng làm NỀN ở MassTimeTileIcon) cho
// icon phụ - tránh lặp cùng 1 biểu tượng "Công giáo" 2-3 lần liên tiếp giữa các mục sidebar khác nhau.
// Vẫn giữ nền tròn amber cho icon phụ - CÙNG 1 tông "badge" xuyên suốt với LearnPlayIcon/HymnIcon.
// ĐÃ THỬ kiểu lồng thật (icon phụ nằm ngay trên mặt bìa, không khoanh tròn riêng) - phản hồi thực tế
// "không ổn", quay lại kiểu badge góc này.
// `showBadge`: true (mặc định) - hiện đủ 2 icon ghép, đúng cỡ tuned cho sidebar (~size 30). Tắt khi
// bị dùng lại ở ngữ cảnh cỡ quá khác - xem SectionHeroBanner (SpaceWebApps.js) và giải thích ở
// LibraryIconSvg.js.
export const DirectoryIcon = ({
                                  size = 32,
                                  bookColor = '#2563eb',    // blue-600 - màu riêng cho "Danh Bạ",
                                  // phân biệt với gia đình (cam) / nhà thờ (teal) / học & chơi (tím)
                                  // / thánh ca (chàm)
                                  groupColor = '#fff',
                                  groupBgColor = '#f59e0b', // amber-500 - cùng màu nền tròn icon phụ
                                  // với LearnPlayIcon/HymnIcon, thống nhất 1 tông "badge"
                                  showBadge = true,
                                  className,
                                  style,
                                  ...props
                              }) => (
    <div
        style={{width: size, height: size, backgroundColor: 'transparent', ...style}}
        className={classNames('flex-shrink-0 rounded-lg flex items-center justify-center', className, showBadge ? "relative" : "")}
        {...props}>
        <FaAddressBook
            size={size * 0.85}
            style={{color: bookColor, filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.2))'}}
        />
        {showBadge && (
            <div
                style={{
                    width: size * 0.46,
                    height: size * 0.46,
                    borderRadius: '9999px',
                    backgroundColor: groupBgColor,
                    position: 'absolute',
                    bottom: '-4%',
                    right: '-4%',
                    filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.25))',
                }}
                className="flex items-center justify-center">
                <FaPeopleGroup size={size * 0.24} style={{color: groupColor}}/>
            </div>
        )}
    </div>
);
